export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/10a16ea8f0629711876da532c1e9215a.svg";